module.exports = __webpack_public_path__ + "media/images/fr_ca/methods_continuum-b524c59d1fc9cdd4b9599ab5388cff04.png";